import api from '../api'; // import your configured axios instance
import { API_URL } from '../config';

// GET all office policies
export const getOfficePolicies = async () => {
  const response = await api.get(`${API_URL}/policies`);
  return response.data;
};

// GET all policies (HR)
export const getPolicies = async () => {
  const response = await api.get(`${API_URL}/policies/hr`);
  return response.data;
};

// GET Policy by ID
export const getPolicyById = async (id) => {
  const response = await api.get(`${API_URL}/policies/${id}`);
  return response.data;
};

export const createPolicy = async (formData) => {
  try {
    const response = await api.post(`${API_URL}/policies/add`, formData);
    return response.data;
  } catch (error) {
    // Log detailed error information
    console.error('Error creating policy:', {
      message: error.message,
      response: error.response ? {
        status: error.response.status,
        statusText: error.response.statusText,
        data: error.response.data // Backend error details are typically here
      } : null,
      request: error.request ? error.request : null
    });

    // Optionally, throw the error to be handled by the caller
    throw error.response?.data || error.message;
  }
};

// DELETE policy
export const deletePolicy = async (id) => {
  const response = await api.delete(`${API_URL}/policies/${id}`);
  return response.data;
};

// PUT update policy
export const updatePolicy = async (id, formData) => {
  const response = await api.put(`${API_URL}/policies/${id}`, formData);
  return response.data;
};

export const fetchPolicyImage = async (imageUrl, containerName) => {
  try {
    // Determine if we're using full URL or container/blob approach
    const isFullUrl = imageUrl.startsWith('http');
    
    const response = await api.get(`${API_URL}/policies/image`, {
      params: isFullUrl 
        ? { blobUrl: imageUrl }
        : { containerName: containerName || 'policy-images', blobName: imageUrl },
      headers: {
        Accept: 'image/*' // Accept any image type
      },
      responseType: 'blob' // Important for binary data
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching policy image:', {
      imageUrl,
      error: {
        message: error.message,
        status: error.response?.status,
        data: error.response?.data
      }
    });
    throw error;
  }
};

/**
 * Gets an image as a data URL (base64 encoded)
 * Useful for direct use in img src tags
 * @param {string} imageUrl - The full Azure Blob Storage URL or blob path
 * @param {string} [containerName] - Optional container name if using blob path
 * @returns {Promise<string>} - Returns data URL (base64 encoded image)
 */
export const fetchPolicyImageAsDataUrl = async (imageUrl) => {
  try {
    // Extract just the blob name from the full URL
    const blobName = imageUrl.replace('https://axopeople.blob.core.windows.net/policy-images/', '');
    
    const response = await api.get(`${API_URL}/policies/image`, {
      params: { blobName },
      headers: {
        Accept: 'image/*'
      },
      responseType: 'blob'
    });

    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(response.data);
    });
  } catch (error) {
    console.error('Error converting image to data URL:', {
      imageUrl,
      error: error.response?.data || error.message
    });
    throw error;
  }
};

/**
 * Gets an image as an ArrayBuffer
 * Useful for PDF/Word document generation
 * @param {string} imageUrl - The full Azure Blob Storage URL (e.g., https://axopeople.blob.core.windows.net/policy-images/filename.png)
 * @returns {Promise<ArrayBuffer>} - Returns ArrayBuffer of the image
 */
export const fetchPolicyImageAsArrayBuffer = async (imageUrl) => {
  try {
    // Extract just the blob name from the full URL
    const blobName = imageUrl.replace('https://axopeople.blob.core.windows.net/policy-images/', '');
    
    const response = await api.get(`${API_URL}/policies/image`, {
      params: { blobName },
      responseType: 'arraybuffer' // Directly get ArrayBuffer from axios
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching image as ArrayBuffer:', {
      imageUrl,
      error: {
        message: error.message,
        status: error.response?.status,
        data: error.response?.data
      }
    });
    throw error;
  }
};